import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { Table, List } from 'antd'
import {
	faThumbsUp,
	faThumbsDown,
	faQuoteLeft,
	faQuoteRight
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import * as Utils from '../../../components/Utils'
import S from '../../../components/Styles'

class TrackList extends Component {
	getFeedbackString(feedback) {
		if (!feedback) {
			return ''
		}

		const { intl } = this.props
		const parts = []

		if (feedback.reason && feedback.reason !== 'OTHER') {
			parts.push(
				intl.formatMessage({
					id: `samples.listen.reasons.${feedback.reason}`
				})
			)
		}

		if (feedback.comment) {
			parts.push(feedback.comment)
		}

		return parts.join(' : ')
	}

	render() {
		const { sample, feedback, selectedIndex, review, selectTrack, mobile } =
			this.props

		return (
			<Table
				className={mobile ? 'playerTableMobile' : 'playerTable'}
				showHeader={false}
				pagination={false}
				dataSource={sample.tracks.map((t, i) => ({
					...t,
					...sample.trackObjects[i]
				}))}
				onRow={(_, index) => ({
					onClick: () => selectTrack(index)
				})}
				rowKey="_id"
				style={{ borderTop: '1px solid #222' }}
			>
				<Table.Column
					key="track"
					render={(_, t, i) => (
						<List.Item.Meta
							avatar={
								<img
									src={Utils.trackArtworkThumbUrl(t)}
									alt=""
									style={S.trackCover}
								/>
							}
							title={
								<span
									style={{
										color:
											selectedIndex === i ?
												colors.text
											:	colors.subtitle
									}}
								>
									{t.title}
								</span>
							}
							description={
								<span
									style={{
										color:
											selectedIndex === i ?
												colors.text
											:	colors.subtitle
									}}
								>
									{t.artist}
								</span>
							}
						/>
					)}
				/>
				{review && (
					<Table.Column
						key="rating"
						width={mobile ? 40 : 80}
						render={(_, t, i) => {
							const fb = feedback[t._id]
							if (fb && fb.rating) {
								return (
									<FontAwesomeIcon
										style={{
											color:
												fb.rating === 2 ?
													colors.yes
												:	colors.no
										}}
										icon={
											fb.rating === 2 ?
												faThumbsUp
											:	faThumbsDown
										}
									/>
								)
							}
							return null
						}}
					/>
				)}
				{review && !mobile && (
					<Table.Column
						key="comment"
						width="40%"
						render={(_, t, i) => {
							const fb = feedback[t._id]
							const comment = this.getFeedbackString(fb)
							if (comment) {
								return (
									<div
										style={{
											color:
												selectedIndex === i ?
													colors.text
												:	colors.subtitle,
											display: 'flex',
											alignItems: 'center'
										}}
									>
										<FontAwesomeIcon icon={faQuoteLeft} />
										<p style={{ margin: '0 10px' }}>
											{comment}
										</p>
										<FontAwesomeIcon icon={faQuoteRight} />
									</div>
								)
							}
							return ''
						}}
					/>
				)}
			</Table>
		)
	}
}

export default injectIntl(TrackList)

const colors = {
	bg: '#181818',
	primary: '#1890ff',
	text: '#fff',
	subtitle: '#999',
	yes: '#52c41a',
	no: '#f5222d'
}
